import {Routes} from '@angular/router';

export const storereleaseCashRoutes: Routes = [
  {
    path: 'storerelease.cash',
    loadComponent: () => import('./storerelease.cash.component').then(m => m.StorereleaseCashComponent),
    data: {title: '预购返预存兑付'},
    children:[
      {
        path: '',
        loadComponent: () => import('./cash.order/cash.order.component').then(m => m.CashOrderComponent),
      },
      {
        path: 'add.equity.cash',
        loadComponent: () => import('./add.equity.cash/add.equity.cash.component').then(m => m.AddEquityCashComponent),
        data: { title: '预购返预存兑付明细' },
      },
      {
        path: 'add.equity.cash/:orderId',
        loadComponent: () => import('./add.equity.cash/add.equity.cash.component').then(m => m.AddEquityCashComponent),
        data: { title: '预购返预存兑付明细' },
      },
    ]
  },
]
